import React, { useCallback } from 'react';
import { Box, Button, Toolbar } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';

import { IBrandsOptions } from 'api/catalog/models';
import { ComputedRoute } from 'utils/ComputedRoute';
import { useQueryString } from 'hooks';

interface IBrandGroup {
  queryString: keyof Pick<IBrandsOptions, 'brandRegex'>;
  label: string;
  key: string;
}

const getAlphabet = () => {
  const alphabet: IBrandGroup[] = [];
  for (let i = 65; i < 91; i++) {
    alphabet.push({
      queryString: 'brandRegex',
      label: String.fromCharCode(i),
      key: `${String.fromCharCode(i)}.*`,
    });
  }
  return alphabet;
};

const BRAND_GROUP_LISTING: IBrandGroup[] = [
  ...getAlphabet(),
  {
    queryString: 'brandRegex',
    label: '0-9',
    key: '[0-9].*',
  },
  {
    queryString: 'brandRegex',
    label: '$.?#',
    key: '[^0-9A-Za-z].*',
  },
];

const BrandGroupRolodex = () => {
  const [searchParams] = useSearchParams();
  const { parsedQueryString } = useQueryString();
  const { startsWith, startsWithGroup, ...rest } = parsedQueryString;

  const isActive = useCallback(
    (grouping: IBrandGroup) => {
      return searchParams.get(grouping.queryString) === grouping.key;
    },
    [searchParams]
  );

  return (
    <Toolbar sx={{ justifyContent: 'center' }}>
      <Box marginBottom='30px'>
        {BRAND_GROUP_LISTING.map((group) => (
          <Button
            key={group.key}
            variant={isActive(group) ? 'contained' : 'outlined'}
            sx={{ padding: '0px 15px', minWidth: 'unset' }}
            component={RouterLink}
            to={ComputedRoute.getBrandsRoute({
              ...rest,
              [group.queryString]: group.key,
            })}
          >
            {group.label}
          </Button>
        ))}
      </Box>
    </Toolbar>
  );
};

export default BrandGroupRolodex;
